import { useSnapshot } from 'valtio';
import { authState } from '../stores/authStore';

/**
 * Returns permission flags for the current user.
 * Use in components to conditionally show/hide UI based on role and permission.
 */
export function usePermissions() {
  const { user } = useSnapshot(authState);

  const role = user?.role || null;
  const permission = user?.permission || null;

  return {
    /** The current user (or null if not authenticated). */
    user,

    /** true if the user has been granted the 'edit' permission, or is an admin/super admin. */
    canEdit: role === 'super_admin' || role === 'company_admin' || permission === 'edit',

    /** true if the user can manage users (invite, change roles, deactivate). */
    canManageUsers: role === 'super_admin' || role === 'company_admin',

    /** true if the user can access admin config (risk matrix, admin settings, etc.). */
    canAccessAdmin: role === 'super_admin' || role === 'company_admin',

    /** true if the user is a super admin with platform-wide access. */
    isSuperAdmin: role === 'super_admin',

    /** true if the user is a company admin. */
    isCompanyAdmin: role === 'company_admin',
  };
}
